<template>
  <div class="popup">
    <div class="popup-header" :class="{ 'has-data': hasData }">
      <MapPin class="popup-icon" />
      <div>
        {{ dataset.total_hospitals }}
        {{ pluralize('hospital', dataset.total_hospitals) }}
        in <b>{{ dataset.name }}</b>
        <div class="greyed-out">
          {{ dataset.reporting_hospitals }}&nbsp;reporting
        </div>
      </div>
    </div>
    <ul class="popup-body" v-if="hasData">
      <li class="statistic">
        <div
          class="statistic-figure"
          :style="{ backgroundColor: $options.colors.NO_DATA }"
        >
          {{ getValue('no_data') }}
        </div>
        <div class="statistic-description greyed-out">No data</div>
      </li>
      <li class="statistic">
        <div
          class="statistic-figure"
          :style="{
            backgroundColor: $options.colors.UNDER_CAPACITY,
            color: '#fff',
          }"
        >
          {{ getValue('under_capacity') }}
        </div>
        <div class="statistic-description">
          Hospitals with healthy {{ resourceStr }} availability
        </div>
      </li>
      <li class="statistic">
        <div
          class="statistic-figure"
          :style="{ backgroundColor: $options.colors.NEAR_CAPACITY }"
        >
          {{ getValue('near_capacity') }}
        </div>
        <div class="statistic-description">
          Hospitals with limited {{ resourceStr }} availability
        </div>
      </li>
      <li class="statistic">
        <div
          class="statistic-figure"
          :style="{ backgroundColor: $options.colors.AT_CAPACITY }"
        >
          {{ getValue('at_capacity') }}
        </div>
        <div class="statistic-description">
          Hospitals with borderline no {{ resourceStr }} availability
        </div>
      </li>
      <li class="statistic">
        <div
          class="statistic-figure"
          :style="{
            backgroundColor: $options.colors.OVER_CAPACITY,
            color: '#fff',
          }"
        >
          {{ getValue('over_capacity') }}
        </div>
        <div class="statistic-description">
          Hospitals with no {{ resourceStr }} availability
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import MapPin from '@/assets/map-pin.svg';
import get from 'lodash/get';
import pluralize from '@/util/pluralize';
import {
  AggregateChartColors,
  CapacityCategories,
  HospitalResources,
} from '@/store/types';

export default {
  components: { MapPin },
  colors: AggregateChartColors,
  props: {
    dataset: {
      type: Object,
      required: true,
    },
    resource: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasData() {
      return !!Object.entries(this.dataset[this.resource]).filter(
        ([key, value]) =>
          key !== CapacityCategories.NO_DATA.toLowerCase() && value > 0,
      ).length;
    },
    resourceStr() {
      return HospitalResources[this.resource.toUpperCase()];
    },
  },
  methods: {
    pluralize,
    getValue(key) {
      // return default of 0, handle instances where the value is <= -1
      return Math.max(get(this.dataset, [this.resource, key], 0), 0);
    },
  },
};
</script>

<style>
.mapboxgl-popup {
  max-width: 300px !important;
  z-index: 1;
}

.mapboxgl-popup-content {
  border-radius: 6px;
  box-shadow: 0px 0px 25px rgba(27, 7, 83, 0.1);
  font-family: 'ttcommons';
  font-weight: 500;
}
</style>

<style lang="scss" scoped>
.popup {
  font-size: 13px;
}

.popup-header {
  align-items: flex-start;
  display: flex;
  font-size: 15px;

  &.has-data {
    border-bottom: 1px solid var(--off-white);
    padding-bottom: 8px;
  }
}

.popup-icon {
  flex-shrink: 0;
  margin-right: 8px;
  margin-top: 4px;
}

.greyed-out {
  color: #b7b7b7;
}

.popup-body {
  list-style: none;
  margin: 0;
  padding: 0;
}

.statistic {
  align-items: center;
  display: flex;
  margin-top: 10px;
}

.statistic-figure {
  border-radius: 100px;
  flex-shrink: 0;
  font-size: 14px;
  font-weight: bold;
  height: 32px;
  line-height: 34px;
  margin-right: 8px;
  text-align: center;
  width: 32px;
}

.statistic-description {
  font-size: 14px;
}
</style>
